import React from 'react';
import '@pathofdev/react-tag-input/build/index.css';
import ReactDOM from 'react-dom';
import SnackbarProvider from 'react-simple-snackbar';
import './index.css';
import './fonts/fonts.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <SnackbarProvider>
      <App />
    </SnackbarProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
